import { Fragment, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { collection } from 'firebase/firestore';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';

import { List, ListItemText, ListItemButton } from '@mui/material';
import { ConversationLink, StyledListItem } from '../../styled/Sidebar.styled';

const UsersList = () => {
  const firestore = useFirestore();
  const navigate = useNavigate();
  const location = useLocation();
  const { userUid, sessionId } = useParams();

  const clickDashboard = location.pathname === '/dashboard';

  const usersCollection = collection(firestore, 'users');

  const { data: users } = useFirestoreCollectionData(usersCollection);

  useEffect(() => {
    if (users && !userUid && !sessionId && clickDashboard)
      navigate(`/dashboard/${users[0].uid}`);
  }, [users, userUid, clickDashboard]);

  return (
    <List>
      {users.map((user) => {
        return (
          <Fragment key={user.uid}>
            <ConversationLink to={`/dashboard/${user.uid}`}>
              <StyledListItem
                disablePadding
                isSelectedItem={userUid === user.uid}
              >
                <ListItemButton>
                  <ListItemText primary={user.email} />
                </ListItemButton>
              </StyledListItem>
            </ConversationLink>
          </Fragment>
        );
      })}
    </List>
  );
};

export default UsersList;
